export const QUEST_BRANCHES = Object.freeze([
  Object.freeze({
    id: 'forest_old_grove',
    areaId: 'forest',
    title: 'The Old Grove',
    attachment: Object.freeze([1, 2]),
    cells: Object.freeze([
      Object.freeze([0, 2]),
      Object.freeze([0, 3]),
      Object.freeze([0, 4]),
      Object.freeze([0, 5])
    ]),
    reward: Object.freeze({
      kind: 'heart_container',
      id: 'old_grove_heart',
      name: 'Crowned Heart',
      amount: 1
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([0, 3]), enemies: Object.freeze(['zombie']) }),
      Object.freeze({ cell: Object.freeze([0, 4]), enemies: Object.freeze(['zombie', 'zombie']) }),
      Object.freeze({ cell: Object.freeze([0, 5]), enemies: Object.freeze(['zombie']) })
    ])
  }),
  Object.freeze({
    id: 'graveyard_forgotten_crypt',
    areaId: 'graveyard',
    title: 'The Forgotten Crypt',
    attachment: Object.freeze([1, 1]),
    cells: Object.freeze([
      Object.freeze([0, 1]),
      Object.freeze([0, 2]),
      Object.freeze([0, 3]),
      Object.freeze([0, 4]),
      Object.freeze([0, 5])
    ]),
    reward: Object.freeze({
      kind: 'supplies',
      id: 'forgotten_crypt_supplies',
      name: "Crypt Keeper's Cache"
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([0, 2]), enemies: Object.freeze(['zombie']) }),
      Object.freeze({ cell: Object.freeze([0, 3]), enemies: Object.freeze(['skeleton']) }),
      Object.freeze({ cell: Object.freeze([0, 4]), enemies: Object.freeze(['skeleton', 'zombie']) }),
      Object.freeze({ cell: Object.freeze([0, 5]), enemies: Object.freeze(['skeleton']) })
    ])
  }),
  Object.freeze({
    id: 'graveyard_warden_tomb',
    areaId: 'graveyard',
    title: "The Warden's Tomb",
    attachment: Object.freeze([2, 3]),
    cells: Object.freeze([
      Object.freeze([3, 3]),
      Object.freeze([4, 3]),
      Object.freeze([4, 4]),
      Object.freeze([4, 5]),
      Object.freeze([3, 5])
    ]),
    reward: Object.freeze({
      kind: 'weapon',
      id: 'gravekeeper_blade_reward',
      weaponId: 'gravekeeper_blade'
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([4, 3]), enemies: Object.freeze(['skeleton', 'zombie']) }),
      Object.freeze({ cell: Object.freeze([4, 4]), enemies: Object.freeze(['skeleton', 'darkWizard']) }),
      Object.freeze({ cell: Object.freeze([4, 5]), enemies: Object.freeze(['skeleton', 'zombie']) }),
      Object.freeze({ cell: Object.freeze([3, 5]), enemies: Object.freeze(['darkWizard']) })
    ])
  }),
  Object.freeze({
    id: 'caves_crystal_vault',
    areaId: 'caves',
    title: 'The Crystal Vault',
    attachment: Object.freeze([3, 4]),
    cells: Object.freeze([
      Object.freeze([4, 4]),
      Object.freeze([4, 5]),
      Object.freeze([4, 6]),
      Object.freeze([3, 6])
    ]),
    reward: Object.freeze({
      kind: 'weapon',
      id: 'crystal_vault_blade_reward',
      weaponId: 'diamond_sword'
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([4, 4]), enemies: Object.freeze(['spider', 'spider']) }),
      Object.freeze({ cell: Object.freeze([4, 5]), enemies: Object.freeze(['orc']) }),
      Object.freeze({ cell: Object.freeze([4, 6]), enemies: Object.freeze(['orc', 'spider']) }),
      Object.freeze({ cell: Object.freeze([3, 6]), enemies: Object.freeze(['orc', 'spider']) })
    ])
  }),
  Object.freeze({
    id: 'caves_luminous_hollow',
    areaId: 'caves',
    title: 'The Luminous Hollow',
    attachment: Object.freeze([1, 4]),
    cells: Object.freeze([
      Object.freeze([1, 5]),
      Object.freeze([0, 5]),
      Object.freeze([0, 6])
    ]),
    reward: Object.freeze({
      kind: 'heart_container',
      id: 'luminous_hollow_heart',
      name: 'Crowned Heart',
      amount: 1
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([1, 5]), enemies: Object.freeze(['spider']) }),
      Object.freeze({ cell: Object.freeze([0, 5]), enemies: Object.freeze(['spider', 'orc']) }),
      Object.freeze({ cell: Object.freeze([0, 6]), enemies: Object.freeze(['orc']) })
    ])
  }),
  Object.freeze({
    id: 'caves_sapphire_aerie',
    areaId: 'caves',
    title: 'The Sapphire Aerie',
    attachment: Object.freeze([3, 1]),
    cells: Object.freeze([
      Object.freeze([4, 1]),
      Object.freeze([4, 0]),
      Object.freeze([3, 0])
    ]),
    reward: Object.freeze({
      kind: 'heart_container',
      id: 'sapphire_aerie_heart',
      name: 'Crowned Heart',
      amount: 1
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([4, 1]), enemies: Object.freeze(['spider']) }),
      Object.freeze({ cell: Object.freeze([4, 0]), enemies: Object.freeze(['orc', 'spider']) }),
      Object.freeze({ cell: Object.freeze([3, 0]), enemies: Object.freeze(['orc']) })
    ])
  }),
  Object.freeze({
    id: 'emberkeep_fallen_battlement',
    areaId: 'emberkeep',
    title: 'The Fallen Battlement',
    attachment: Object.freeze([1, 4]),
    cells: Object.freeze([
      Object.freeze([0, 4]),
      Object.freeze([0, 5]),
      Object.freeze([1, 5])
    ]),
    reward: Object.freeze({
      kind: 'heart_container',
      id: 'fallen_battlement_heart',
      name: 'Crowned Heart',
      amount: 1
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([0, 4]), enemies: Object.freeze(['emberGuard']) }),
      Object.freeze({ cell: Object.freeze([0, 5]), enemies: Object.freeze(['emberGuard', 'cinderImp']) }),
      Object.freeze({ cell: Object.freeze([1, 5]), enemies: Object.freeze(['cinderImp', 'emberGuard']) })
    ])
  }),
  Object.freeze({
    id: 'purpledooms_eclipsed_sanctum',
    areaId: 'purpledooms',
    title: 'The Eclipsed Sanctum',
    attachment: Object.freeze([2, 3]),
    cells: Object.freeze([
      Object.freeze([1, 3]),
      Object.freeze([1, 4]),
      Object.freeze([0, 4])
    ]),
    reward: Object.freeze({
      kind: 'heart_container',
      id: 'eclipsed_sanctum_heart',
      name: 'Crowned Heart',
      amount: 1
    }),
    encounters: Object.freeze([
      Object.freeze({ cell: Object.freeze([1, 3]), enemies: Object.freeze(['shadowWolf']) }),
      Object.freeze({ cell: Object.freeze([1, 4]), enemies: Object.freeze(['darkKnight', 'shadowWolf']) }),
      Object.freeze({ cell: Object.freeze([0, 4]), enemies: Object.freeze(['darkKnight']) })
    ])
  })
])
